/* jslint browser: true */
import React, { Component } from 'react';
import PropTypes            from 'prop-types';

/**
 * Titre du bloc de type annexe
 */
class AnnexeBlockTitle extends Component {
    constructor(props){
        super(props);
    }

    render(){
        return (<div>
                    <span style={{color:"#FFF"}}>{this.props.titre}</span>
                    <div className="title-icon" style={{ cursor: 'pointer' }}><i className="fa fa-caret-down" aria-hidden="true" /></div>
                </div>);
    }
}

AnnexeBlockTitle.propTypes = { titre: PropTypes.string };

export default AnnexeBlockTitle;



// WEBPACK FOOTER //
// ./src/components/annexes/AnnexeBlockTitle.js